module.exports = __webpack_public_path__ + "img/about-3.c565ccee.webp";